import { numberToPrettyString } from '@cian/utils';

import { IOffer } from '../../../../types/offer';

const EN_DASH = '–';

function roundArea(value: number): number {
  return Math.round(value * 10) / 10;
}

export function getMultiAdsAreaRange(offer: IOffer): string | undefined {
  const areas = (offer.areaParts ?? [])
    .map(part => part.area)
    .filter((value): value is number => typeof value === 'number');

  if (areas.length === 0) {
    return undefined;
  }

  const min = Math.min(...areas);
  const max = Math.max(...areas);

  if (min === max) {
    return `${numberToPrettyString(roundArea(min))} м²`;
  }

  return `${numberToPrettyString(roundArea(min))} ${EN_DASH} ${numberToPrettyString(roundArea(max))} м²`;
}
